/* em-systems.js - the Formulas page (systems/index.html), its script as it was: the two Formulas, the rest of the house, the parts. Links and the bag go to Shopify through EMBag. */

/* Every product, price and photograph on this page is Energy Muse's own, taken
   from their live catalogue. The three "founder favourites" this page used to
   list in prose — a beginner system, a sleep system, a must-have trio — turned
   out to be the Formulas and the bundles, which are real things you can buy,
   so they are sold here instead of described. */
(function(){
  var S=window.EM_ASSET_BASE||'/';
  /* The three-part architecture is Energy Muse's own and it is the whole point
     of a Formula: one frequency clears the room, one steadies it, one aims it
     at what the room is for. An earlier draft of this page guessed at the
     contents and got them wrong - these are read off their product copy. */
  var FORMULAS=[
    {id:'formula-home', n:'Harmonious Home Frequency Formula', room:'For the living room',
     p:299.88, img:S+'formula-home.webp',
     say:'A living room holds onto more than you notice \u2014 the friction of a hard conversation, the static of a long commute, the weight of a full day. Most spaces just keep it. This one is built to move it on.',
     arch:[['Clear','417','Releases the friction you carried home, so the room is not holding onto your day.'],
           ['Stabilize','639','Holds the space in softness, easing tension back to a steady baseline.'],
           ['Direct','963','Aims the room at open communication and mental ease.']],
     inc:'All three generators, a display case that houses them as one piece, and a canvas bag.'},
    {id:'formula-sleep', n:'Restorative Sleep Frequency Formula', room:'For the bedroom',
     p:299.88, img:S+'formula-sleep.webp',
     say:'A bedroom absorbs the loop of unfinished thoughts and the static of a day that never fully powered down. The next Formula in the system, tuned for the room you are least awake in.',
     arch:[['Clear','417','Releases the day\u2019s overthinking, so the room is not holding what you brought into it.'],
           ['Stabilize','7.83','Earth\u2019s own resonance \u2014 grounds the room in safety and familiarity.'],
           ['Direct','528','Aims the room at cellular restoration and emotional reset.']],
     inc:'All three generators, a display case that houses them as one piece, and a canvas bag.'}
  ];
  var PARTS=[
    {id:'home-frequency', n:'Home Frequency Bundle',     p:158.88, kind:'Bundle',    img:S+'home-frequency.webp'},
    {id:'copper-conductor', n:'Copper Conductor Bundle', p:84.88,  kind:'Bundle',    img:S+'copper-conductor.webp'},
    {id:'copper-plate', n:'Solid Copper Plate',          p:44.88,  kind:'Copper',    img:S+'copper-plate.webp'},
    {id:'copper-spheres', n:'Copper Activation Mini-Spheres', p:24.88, kind:'Copper', img:S+'copper-spheres.webp'},
    {id:'copper-pyramid', n:'Solid Copper Pyramid',      p:24.88,  kind:'Copper',    img:S+'copper-pyramid.webp', out:true},
    {id:'frequency-bag', n:'Frequency Generator Bag',    p:18.88,  kind:'Accessory', img:S+'frequency-bag.webp'}
  ];

  /* Sept 14: the prices and the Sold out above are the prototype's. The page section writes each piece's price, stock and
     button from the store (EM_SYS_LIVE, by the same rule as every other card - snippets/em-choose.liquid); a piece the
     store doesn't carry isn't shown. */
  var LIVE=window.EM_SYS_LIVE;
  if(LIVE) FORMULAS.concat(PARTS).forEach(function(c){
    var L=LIVE[c.id]; if(!L){ c.missing=true; return; }
    c.p=L.price; c.out=!!L.out; c.choose=L.choose||''; c.link=L.link;
  });
  function buy(c){
    return c.out?'<span class="psold">Sold out</span>'
      :c.choose?'<a class="padd" href="'+c.link+(String(c.link).indexOf('?')<0?'?':'&amp;')+'choose=1">'+c.choose+'</a>'
      :'<button class="padd" type="button" data-id="'+c.id+'">Add to Bag</button>';
  }

  var feat=document.getElementById('feat');
  FORMULAS.forEach(function(c){
    if(c.missing) return;
    var el=document.createElement('div'); el.className='fcell';
    var arch=c.arch.map(function(a){
      return '<li><span class="step">'+a[0]+'</span><span class="ahz">'+a[1]+'<em>Hz</em></span>'
           + '<span class="asay">'+a[2]+'</span></li>';}).join('');
    var fhref=EMBag.href(c.id);
    el.innerHTML='<a class="plink" href="'+fhref+'"><span class="shot"><img src="'+c.img+'" alt="'+c.n+'" loading="lazy"></span></a>'
      +'<div class="body"><span class="room">'+c.room+'</span><h3><a class="plink" href="'+fhref+'">'+c.n+'</a></h3>'
      +'<p class="say">'+c.say+'</p>'
      +'<ol class="arch">'+arch+'</ol>'
      +'<p class="inc">'+c.inc+'</p>'
      +'<span class="pr">$'+c.p.toFixed(2)+'</span>'
      +buy(c)+'</div>';
    feat.appendChild(el);
  });

  /* The rest of the house: her doc, verbatim - room, name, the three layers
     in her order and her reason lines (first letter up, a full stop added).
     Everything else on the card is the catalogue: EM_FREQ by hz gives the
     generator's id, photo and price, so the sum is real and the bag gets
     three real products. .gprice opts the sum into em-prices' generator hold. */
  var ROOMS=[
    {room:'For the kid’s bedroom', ages:[
      {n:'Ages 0–7', arch:[['Stabilize','7.83','Grounds the room in safety, comfort, and familiarity.'],
                               ['Clear','528','Gently resets the nervous system, cellular restoration for little bodies still learning to self-regulate.'],
                               ['Direct','639','Directs the space toward bonding, softness, and connection.']]},
      {n:'Ages 8–12', arch:[['Clear','417','Clears the overstimulation of a growing social world — school, friendships, screen time.'],
                                ['Stabilize','7.83','Holds the room in a steady, safe baseline.'],
                                ['Direct','174','Releases physical tension as bodies grow and change.']]},
      {n:'Ages 13–18', arch:[['Clear','417','Clears the emotional and social accumulation of the teenage day.'],
                                 ['Stabilize','174','Eases physical tension during a stage of rapid growth and stress.'],
                                 ['Direct','963','Directs the space toward mental clarity and communication, supporting a mind that’s decompressing and individuating.']]}
    ]},
    {room:'For the office', n:'Focused Flow', arch:[['Clear','417','Clears dysregulation.'],
                                                   ['Stabilize','174','Releases tension, holds a steady baseline.'],
                                                   ['Direct','1111','Directs the space toward opportunity and momentum.']]},
    {room:'For the kitchen', n:'Nourished Home', arch:[['Clear','417','Clears the space.'],
                                                       ['Stabilize','528','Holds an uplifting, energizing charge.'],
                                                       ['Direct','963','Directs the space toward conversation, creativity, downloads.']]}
  ];
  var byHz=(window.EM_FREQ_BY&&EM_FREQ_BY.hz)||function(){return null;};
  function roomBody(f,noTitle){
    var gens=f.arch.map(function(a){return byHz(a[1]);});
    var sum=gens.reduce(function(t,g){return t+(g?g.price:0);},0);
    return (noTitle?'':'<h3>'+f.n+'</h3>')
      +'<ol class="rarch">'+f.arch.map(function(a){
          return '<li><span class="rk"><span class="step">'+a[0]+'</span><span class="ahz">'+a[1]+'<em>Hz</em></span></span>'
               + '<span class="asay">'+a[2]+'</span></li>';}).join('')+'</ol>'
      +'<div class="rthumbs">'+gens.map(function(g){
          return g?'<a class="plink" href="'+EMBag.href(g.id)+'" aria-label="'+g.hz+'Hz Frequency Generator"><img src="'+S+g.img.split('/').pop()+'" alt="" loading="lazy"></a>':'';}).join('')+'</div>'
      +'<div class="rbuy"><button class="padd radd" type="button" data-hz="'+f.arch.map(function(a){return a[1];}).join(',')+'">Add all three</button>'
      /* em-prices holds generator prices at load; a card re-rendered by a tab
         click after that would show the real sum beside three held ones, so
         this paints the hold itself once the mode is known. */
      +(window.EM_PRICE_MODE==='hold'
          ?'<span class="pr gprice" data-em-held="$'+sum.toFixed(2)+'" title="Price to be confirmed">$\u2014</span>'
          :'<span class="pr gprice">$'+sum.toFixed(2)+'</span>')+'</div>';
  }
  var rooms=document.getElementById('rooms');
  ROOMS.forEach(function(r){
    var el=document.createElement('div'); el.className='fcell rcard';
    var head='<span class="room">'+r.room+'</span>';
    if(r.ages){
      head+='<div class="rtitle"><h3>Ages</h3><div class="ages" role="group" aria-label="Age range">'+r.ages.map(function(a,i){
        return '<button type="button" aria-pressed="'+(i?'false':'true')+'" data-i="'+i+'">'+a.n.replace('Ages ','')+'</button>';}).join('')+'</div></div>';
      el.innerHTML=head+'<div class="rbody">'+roomBody(r.ages[0],true)+'</div>';
      el.querySelector('.ages').addEventListener('click',function(e){
        var b=e.target.closest('button'); if(!b)return;
        el.querySelectorAll('.ages button').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
        el.querySelector('.rbody').innerHTML=roomBody(r.ages[+b.getAttribute('data-i')],true);
      });
    } else {
      el.innerHTML=head+'<div class="rbody">'+roomBody(r)+'</div>';
    }
    rooms.appendChild(el);
  });
  document.addEventListener('click',function(e){
    var b=e.target.closest('.radd'); if(!b||!window.EMBag)return;
    b.getAttribute('data-hz').split(',').forEach(function(hz){
      var g=byHz(hz); if(!g)return;
      EMBag.add({id:g.id,name:g.hz+'Hz Frequency Generator',price:g.price,img:S+g.img.split('/').pop(),link:EMBag.href(g.id)});
    });
    b.textContent='Added all three'; b.classList.add('done');
    setTimeout(function(){b.textContent='Add all three'; b.classList.remove('done');},1800);
  });

  var parts=document.getElementById('parts');
  PARTS.forEach(function(c){
    if(c.missing) return;
    var el=document.createElement('div'); el.className='pcard'+(c.out?' out':'');
    var href=EMBag.href(c.id);
    el.innerHTML='<a class="plink" href="'+href+'"><span class="shot"><img src="'+c.img+'" alt="'+c.n+'" loading="lazy"></span>'
      +'<span class="kind">'+c.kind+'</span><span class="nm">'+c.n+'</span></a>'
      +'<span class="pr">$'+c.p.toFixed(2)+'</span>'
      +buy(c);
    parts.appendChild(el);
  });

  var byId={}; FORMULAS.concat(PARTS).forEach(function(c){byId[c.id]=c;});
  document.addEventListener('click',function(e){
    var b=e.target.closest('button.padd'); if(!b||!window.EMBag)return;
    var c=byId[b.getAttribute('data-id')]; if(!c)return;
    EMBag.add({id:c.id,name:c.n,price:c.p,img:c.img,link:location.pathname});
  });
})();
